/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordsdonotmatch3Inputs */

const en_passwordsdonotmatch3 = /** @type {(inputs: Passwordsdonotmatch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwords do not match`)
};

const de_passwordsdonotmatch3 = /** @type {(inputs: Passwordsdonotmatch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Passwörter stimmen nicht überein.`)
};

/**
* | output |
* | --- |
* | "Passwords do not match" |
*
* @param {Passwordsdonotmatch3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordsdonotmatch3 = /** @type {((inputs?: Passwordsdonotmatch3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordsdonotmatch3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordsdonotmatch3(inputs)
	return de_passwordsdonotmatch3(inputs)
});
export { passwordsdonotmatch3 as "passwordsDoNotMatch" }